import { NgClass, NgIf, NgStyle } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TFMService } from 'app/mock-api/tfm.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-banner_section-type01',
  standalone: true,
  imports: [NgIf,NgClass,NgStyle],
  templateUrl: './banner_section-type01.component.html',
  styleUrl: './banner_section-type01.component.scss'
})
export class BannerSectionType01Component implements OnChanges {
  @Input() options: any = {}
  
  public view: any = {
    isCorparateRoute: false,
    bannerLoaded: false,
    bannerError: false,
  };

  constructor( private _tfmService : TFMService,private router: Router ) {  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] && this.options?.imageHref) {
      this.view.bannerLoaded = false;
      this.view.bannerError = false;
    }
  }

  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      // this._tfmService.log(this.view);

    });
    this.router.events.subscribe(() => {
      this.view.isCorparateRoute = this.router.url.includes('/corporate-travel');
    });
  }
}
